import { routes } from './routes';

export const navbarItems = [
  { label: 'My products', target: routes.HOME, external: false },
  { label: 'Knowledge base', target: '', external: true },
  { label: 'Profile', target: routes.PROFILE, external: false },
];

export const dronesHeaderItems = [
  '',
  'Drone S/N',
  'Details',
  'Support',
];

export const accessoriesHeaderItems = [
  '',
  'Camera S/N',
  'Details',
  'Support',
];

export const softwareHeaderItems = [
  '',
  'Version',
  'Download',
];



// WEBPACK FOOTER //
// ./src/static/uiElementsData.ts